import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { ModelAutocompleteField, SingleOptionSelectorField } from '@front/squirtle'

const Row1 = ({ afterChangeJob }) =>
  <Grid container spacing={1} size={12}>
    <Grid size={4}>
      <ModelAutocompleteField
        name='job'
        label={I18n.t('order.id.alter')}
        model_name={'order'}
        searchMode='search'
        searchQuery={'contains'}
        autocompleteKey={'order_client_id'}
        labelKeys={['order_client_id']}
        selectKeys={['job']}
        selectFirst={false}
        required
        config={{
          forced_filter: { status: ['created', 'standby'] }
        }}
        afterChange={afterChangeJob}
      />
    </Grid>
    <Grid size={2}>
      <SingleOptionSelectorField
        name='important'
        labelPlacement='start'
        optionLabel={I18n.t('broadcast.important')}
        valueType='checkbox'
      />
    </Grid>
  </Grid>


const JobSection = ({ afterChangeJob }) => <>
  <StepLabel>
    <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 'h6.fontSize', color: 'text.title' }}>
      <Typography variant='h5'>{I18n.t('broadcast.model.job')}</Typography>
    </Box>
  </StepLabel>
  <StepContent>
    <Box sx={{ boxShadow: 6, borderRadius: 1, p: 2 }}>
      <Row1 afterChangeJob={afterChangeJob} />
    </Box>
  </StepContent>
</>

export default JobSection
